import crypto from "crypto";
import * as Redis from "ioredis";

const connections = {};

export default function connectRedis(config, cluster = false) {
  const key = crypto
    .createHash("SHA256")
    .update(JSON.stringify(config))
    .digest("hex");

  if (connections[key]) {
    return connections[key];
  } else {
    if (cluster) {
      const redis = new Redis.Cluster([config]);
      connections[key] = redis;
      return redis;
    } else {
      const redis = new Redis(config);
      connections[key] = redis;
      return redis;
    }
  }
}
